import React from 'react';
import { Zap, Bot, MessageSquare } from 'lucide-react';
import { motion } from 'framer-motion';
import { BenefitCard } from '../ui/BenefitCard';
import { MetricsPanel } from '../ui/MetricsPanel';
import { ScalePanel } from '../ui/ScalePanel';

const benefits = [
  {
    icon: Zap,
    title: 'Directe Antwoorden',
    description: 'Geen wachttijden meer voor klanten dankzij directe, accurate antwoorden die 24/7 beschikbaar zijn. Onze AI verwerkt vragen direct, met als resultaat:',
    bullets: [
      'Van minuten naar seconden responstijd',
      'Consistente servicekwaliteit in alle tijdzones',
      'Directe oplossingen voor veelvoorkomende vragen'
    ]
  },
  {
    icon: Bot,
    title: 'Zelflerend Systeem',
    description: 'Onze AI ontwikkelt zich voortdurend door elke interactie, voor steeds persoonlijkere ondersteuning:',
    bullets: [
      'Adaptieve antwoorden gebaseerd op klanthistorie',
      'Patroonherkenning voor proactieve hulp',
      'Continue verbetering door feedback'
    ]
  },
  {
    icon: MessageSquare,
    title: 'Naadloze Integratie',
    description: 'Integreer onze AI-assistent probleemloos met uw bestaande systemen:',
    bullets: [
      'Snelle implementatie op populaire platforms',
      'Volledig aan te passen aan uw huisstijl',
      'Uitgebreide API voor maatwerk'
    ]
  }
];

interface BenefitsSectionProps {
  onChatOpen: () => void;
}

export function BenefitsSection({ onChatOpen }: BenefitsSectionProps) {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 bg-brand-50 text-brand-600 px-4 py-1.5 rounded-full font-medium mb-6"
          >
            <Zap size={20} />
            Bewezen Voordelen
          </motion.div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Transformeer Uw Klantenservice
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-xl text-gray-600">
              Vernieuw uw klantenservice met AI-gestuurde automatisering zonder in te leveren op kwaliteit. Verlaag kosten, verhoog efficiëntie en lever uitzonderlijke service op schaal.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {benefits.map((benefit, index) => (
            <BenefitCard key={index} {...benefit} />
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8 bg-white rounded-xl p-8 shadow-sm">
          <MetricsPanel />
          <ScalePanel onChatOpen={onChatOpen} />
        </div>
      </div>
    </section>
  );
}